import { Chip, Stack, Typography } from '@mui/material';
import { BasicCard } from '@PorkyCol/cards';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';

import { getOrdersCookingService } from '@/services';
import React, { useCallback, useMemo, useRef } from 'react';
import { TITLE } from '@/utils/constants';
import { CardOrderDetail } from '@modules/orders/components/CardOrderDetail';
import { OrderDetailStatus } from '@modules/orders/types';
import { useVirtualizer } from '@tanstack/react-virtual';

export enum OrderStatus {
  Created = 'created',
  Cancelled = 'cancelled',
  InProgress = 'in_progress',
  Delivered = 'delivered',
  Pending = 'pending',
  Closed = 'closed',
  Paid = 'paid',
  REOPEN = 're_open',
}
const OrderDetailStatusArray = Object.values(OrderDetailStatus);
export default function CookingPanelPage() {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: ['orders', 'cooking'],
    queryFn: getOrdersCookingService,
    select: (order) => {
      const status = [
        OrderStatus.Created,
        OrderStatus.InProgress,
        OrderStatus.Pending,
        OrderStatus.Delivered,
      ];
      const filteredOrders = order?.filter((item: any) => status.includes(item.status));
      const ordersDetails: any = [];
      filteredOrders?.forEach((tp: any) => {
        if (tp.status)
          tp.ordersDetails.forEach((orderDetail: any) => {
            ordersDetails.push({ ...orderDetail, table: tp.table });
          });
      });
      return ordersDetails;
    },
  });
  const amountProductsByStatus = useMemo(() => {
    const stackAccumulate: Record<string, number> = {};
    OrderDetailStatusArray?.forEach?.((orderTitle) => {
      let stack = 0;
      data?.forEach?.((order: any) => {
        if (order.status === orderTitle) {
          stack += 1;
        }
      });
      stackAccumulate[orderTitle] = stack;
    });
    return stackAccumulate;
  }, [data]);

  return (
    <>
      <Helmet>
        <title> {TITLE}: Cooking Panel</title>
      </Helmet>
      <div className=" px-2 md:px-0 flex flex-col md:landscape:flex-col  lg:landscape:flex-row lg:flex-row gap-3 sm:gap-6 justify-center w-full items-center sm:items-start flex-wrap lg:flex-nowrap">
        {OrderDetailStatusArray?.map?.((title, key) => (
          <div
            className="flex flex-col md:landscape:max-w-full md:landscape:min-w-full bg-white lg:landscape:min-w-80 lg:landscape:max-w-80 lg:min-w-80 lg:max-w-80  min-w-full w-full gap-4 overflow-x-hidden"
            key={title + key}
          >
            <div className="px-2">
              <BasicCard>
                <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle2">{title}</Typography>{' '}
                  <Chip variant="filled" label={amountProductsByStatus?.[title]} />
                </Stack>
              </BasicCard>
            </div>
            <div className="gap-4 flex p-2 flex-row landscape:flex-row lg:flex-col bg-white lg:landscape:flex-col overflow-x-scroll md:landscape:overflow-x-scroll w-100">
              {data
                ?.filter?.((item: any, key2: number) => item.status === title)
                .map((ordersDetail: any) => (
                  <CardOrderDetail
                    key={ordersDetail.id}
                    orderId={ordersDetail.orderId.slice(ordersDetail.orderId.length / 1.8)}
                    table={ordersDetail?.table ?? ''}
                    orderDetail={ordersDetail}
                    prevStatus={OrderDetailStatusArray[key - 1] ?? OrderDetailStatus.created}
                    nextStatus={
                      key < OrderDetailStatusArray.length - 1
                        ? OrderDetailStatusArray[key + 1]
                        : OrderDetailStatus.done
                    }
                  />
                ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
